const MULTI_SELECT_VALUE_MAX_HEIGHT = 104;

const isMultiSelect = (state) => state?.selectProps?.isMulti;

export const customStyle = (height = 44) => ({
  control: (provided, state) => ({
    ...provided,
    border: 0,
    borderColor: state.isFocused ? "#023A66" : provided.borderColor,
    "&:hover": { borderColor: "#023A66 !important" },
    height: isMultiSelect(state) ? "auto" : height,
    minHeight: height,
    boxShadow: "none",
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: isMultiSelect(state) ? "auto" : height,
    minHeight: height,
    maxHeight: isMultiSelect(state) ? MULTI_SELECT_VALUE_MAX_HEIGHT : height,
    overflowY: isMultiSelect(state) ? "auto" : provided.overflowY,
    overflowX: "hidden",
    padding: "0 8px",
    flexWrap: isMultiSelect(state) ? "wrap" : provided.flexWrap,
  }),

  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),

  option: (styles, { data, isFocused, isSelected, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isSelected ? "#023A66" : data.color,
    color: isDisabled ? "#ccc" : isSelected ? "white" : data.color,
    cursor: isDisabled ? "not-allowed" : "default",
  }),

  menu: (provided) => ({ ...provided, zIndex: 9999 }),
  menuList: (provided) => ({ ...provided, zIndex: 10 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  multiValue: (provided) => ({
    ...provided,
    maxWidth: "100%",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    overflow: "visible",
    whiteSpace: "normal",
  }),
});

export const customStyleForMultiSelect = {
  control: (provided, state) => {
    return {
      ...provided,
      border: 0,
      minHeight: "44px",
      height: "auto",
      borderColor: state.isFocused ? "#023A66" : provided.borderColor,
      "&:hover": {
        borderColor: "#023A66 !important",
      },
    };
  },

  valueContainer: (provided) => ({
    ...provided,
    minHeight: "44px",
    height: "auto",
    maxHeight: `${MULTI_SELECT_VALUE_MAX_HEIGHT}px`,
    overflowY: "auto",
    overflowX: "hidden",
    flexWrap: "wrap",
  }),

  option: (styles, { data, isFocused, isSelected, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isSelected ? "#F3F5F7" : data.color,
    color: isDisabled ? "#ccc" : isSelected ? "#023A66" : data.color,
    cursor: isDisabled ? "not-allowed" : "default",
    padding: "10px 14px",
    marginTop: "8px",
    marginBottom: "8px",
    height: data.label.length > 31 ? "80px" : "44px",
    display: "flex",
    alignItems: "center",
    "&:active": {
      backgroundColor: "#F3F5F7",
    },
    "&:hover": {
      backgroundColor: "#F3F5F7",
    },
  }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),

  menuList: (provided, state) => ({
    ...provided,
    zIndex: 10,
    padding: "0px 10px 14px",
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),

  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#F3F5F7", // Custom background color for selected chips
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#023A66", // Text color inside the chip
    fontSize: "14px",
    fontFamily: "urwgeometric-medium",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#023A66", // Color of the clear icon
    ":hover": {
      backgroundColor: "#F3F5F7",
      color: "#023A66",
    },
  }),
};
